import styled from 'styled-components'

export const DeskWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.body};
`

export const DeskContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

export const DeskLeftPanel = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: hidden;
`

// Cart panel: ~40% of the screen, never narrower than 600px (1536x864)
// and capped so the product grid keeps its room on 1920x1080.
export const DeskRightPanel = styled.div`
  flex: 0 0 clamp(600px, 40%, 760px);
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-left: 1px solid var(--color-line);
  overflow: hidden;
`
